import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { CommonService } from './commonService';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class SvlServices {
  private accessToken: any;
  public retailerData: any;


  public constructor(_http: HttpClient, private commonService: CommonService) {
    this.accessToken = this.commonService.getAccessToken();
  }

  public setRetailerData(value) {
    this.retailerData = value;
  }

  public getRetailerData() {
    return this.retailerData;
  }

  public getRetailerList(body, page, isAll) {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.accessToken}`,
    });
    let url = `api/svl-services-get-summary?page=${page}&limit=20&isAll=${isAll}`;
    return this.commonService.regularPostRequest(url, body, headers);
  }

  public getretailerSummary(id, merchant): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/svl-services-get-summary-by-id?id=${id}&merchantType=${merchant}`;
    return this.commonService.regularGetRequest(url, headers);
  }

  public manageCard(id, merchant): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    const url = `api/svl-get-card-details-by-id?id=${id}&merchantType=${merchant}`;
    return this.commonService.regularGetRequest(url, headers);
  }
  public getRetailerFinancialHistory(body, page, isAll): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${this.accessToken}`,
      'Content-Type': 'application/json'
    });
    let url = `api/svl-financial-history?&page=${page}&merchantType=JM&isAll=${isAll}&limit=50`;
    if (body.dateFrom) {
      url += `&dateFrom=${body.dateFrom}`;
    }
    if (body.dateTo) {
      url += `&dateTo=${body.dateTo}`;
    }
    if (body.consumerId) {
      url += `&consumerId=${body.consumerId}`;
    }
    if (body.channelType) {
      url += `&channelType=${body.channelType}`;
    }
    return this.commonService.regularGetRequest(url, headers);
  }
}
